const validate = values => {
	const errors = {};
	if (!values.items_buy || !values.items_buy.length) {
	  errors.items_buy = { _error: 'Debe ingresarse al menos un miembro.' };
	} else {
	  const items_buyArrayErrors = [];
	  values.items_buy.forEach((item_buy, item_buyIndex) => {
		const itemBuyErrors = {};
		if (!item_buy || !item_buy.items_buy_detail) {
		  itemBuyErrors.items_buy_amout = 'Este campo es obligatorio';
		  items_buyArrayErrors[item_buyIndex] = itemBuyErrors;
		}
		if (!item_buy || !item_buy.items_buy_amout) {
		  itemBuyErrors.items_buy_amout = 'Este campo es obligatorio';
		  items_buyArrayErrors[item_buyIndex] = itemBuyErrors;
		}
	  });
	  if (items_buyArrayErrors.length) {
		errors.items_buy = items_buyArrayErrors;
	  }
	}
	return errors;
  };

  export default validate;



/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsItemsBuyForm.js
 **/